import React, { useEffect, useState } from "react";

import Header from "./Header";
import MenuBar from "./MenuBar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import { GetVisData } from "./ChartData";
import CommonChart from "./CommonChart";
import { useAuth } from "../context/API_Client";
import preciseToSecs from "./Utils";
import DateRangeDropdown from "./DateRangeDropdown";
import BusinessDropdown from "./BusinessDropdown";
// import { Chart } from "chart.js";

const SuccessRate = () => {
  const initialDateRange = {
    fromDate: preciseToSecs(
      new Date(new Date().getTime() - 15 * 60 * 1000)
    ).toISOString(),
    toDate: preciseToSecs(new Date()).toISOString(),
    calendarInterval: "1m",
  };

  const initialUnits = {
    legalEntityCode: null,
    clientPosId: null,
  };

  const { getUserDetails, getAccessToken } = useAuth();
  const merchantId = getUserDetails().merchantId;
  const accessToken = getAccessToken();

  const [dateRange, setDateRange] = useState(initialDateRange);
  const [units, setUnits] = useState(initialUnits);
  const [overallData, setOverallData] = useState({});
  const [currencyData, setCurrencyData] = useState({});
  const [countryData, setCountryData] = useState({});
  const [pspData, setPspData] = useState({});
  const [paymentMethodData, setPaymentMethodData] = useState({});
  const dateRangeAndUnitsChange = function () {
    GetVisData(
      "success_rate_overall_report",
      null,
      "timestamp",
      ["Success Rate"],
      dateRange,
      units,
      merchantId,
      accessToken,
      setOverallData
    );
    GetVisData(
      "success_rate_currency_report",
      "currencyCode",
      "timestamp",
      ["Success Rate"],
      dateRange,
      units,
      merchantId,
      accessToken,
      setCurrencyData
    );
    GetVisData(
      "success_rate_country_report",
      "countryCode",
      "timestamp",
      ["Success Rate"],
      dateRange,
      units,
      merchantId,
      accessToken,
      setCountryData
    );
    GetVisData(
      "success_rate_psp_report",
      "pspCode",
      "timestamp",
      ["Success Rate"],
      dateRange,
      units,
      merchantId,
      accessToken,
      setPspData
    );
    GetVisData(
      "success_rate_payment_method_report",
      "paymentMethod",
      "timestamp",
      ["Success Rate"],
      dateRange,
      units,
      merchantId,
      accessToken,
      setPaymentMethodData
    );
  };

  useEffect(() => {
    dateRangeAndUnitsChange();
    console.log(dateRange);
    console.log("units", units);
  }, [dateRange, units]);

  const [chartOptions, setChartOptions] = useState({
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
    },
    // scale: {
    //     pointLabels :{
    //        fontStyle: "bold",
    //     }
    // },
  });

  const dropdownStyles = {
    display: "flex",
    flexDirection: "row",
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h5>Success Rate Reports</h5>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/reports/success_rate">Reports</Link>
                  </li>
                  <li className="breadcrumb-item active">Success Rate</li>
                </ol>
              </div>
            </div>
          </div>
          <div style={dropdownStyles}>
            <DateRangeDropdown
              dateRange={initialDateRange}
              setDateRange={setDateRange}
            />
            <BusinessDropdown units={initialUnits} setUnits={setUnits} />
          </div>
        </section>
        <section className="content">
          <div className="card card-primary card-outline">
            <div className="card-header">
              <h3
                className="card-title"
                title="Collapse"
                data-card-widget="collapse"
                style={{ cursor: "pointer" }}
              >
                {" "}
                &nbsp;&nbsp;<i className="far fa-chart-bar"></i>&nbsp; Overall
                Success Rate Time Series Chart
              </h3>
              <div className="card-tools">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="collapse"
                >
                  <i className="fas fa-minus"></i>
                </button>
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="maximize"
                >
                  <i className="fas fa-expand"></i>
                </button>
              </div>
            </div>
            <div className="card-body">
              <CommonChart chartData={overallData} options={chartOptions} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3
                    className="card-title"
                    title="Collapse"
                    data-card-widget="collapse"
                    style={{ cursor: "pointer" }}
                  >
                    {" "}
                    &nbsp;&nbsp;<i className="far fa-chart-bar"></i>&nbsp; PSP
                    wise Successs Rate Time Series Chart
                  </h3>
                  <div className="card-tools">
                    {/* <DateRangeDropdown/> */}
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="collapse"
                    >
                      <i className="fas fa-minus"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="maximize"
                    >
                      <i className="fas fa-expand"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <CommonChart chartData={pspData} options={chartOptions} />
                </div>
              </div>
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3
                    className="card-title"
                    title="Collapse"
                    data-card-widget="collapse"
                    style={{ cursor: "pointer" }}
                  >
                    {" "}
                    &nbsp;&nbsp;<i className="far fa-chart-bar"></i>&nbsp;
                    Country wise Successs Rate Time Series Chart
                  </h3>

                  <div className="card-tools">
                    {/* <DateRangeDropdown/> */}
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="collapse"
                    >
                      <i className="fas fa-minus"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="maximize"
                    >
                      <i className="fas fa-expand"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <CommonChart chartData={countryData} options={chartOptions} />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3
                    className="card-title"
                    title="Collapse"
                    data-card-widget="collapse"
                    style={{ cursor: "pointer" }}
                  >
                    {" "}
                    &nbsp;&nbsp;<i className="far fa-chart-bar"></i>&nbsp;
                    Currency wise Successs Rate Time Series Chart
                  </h3>

                  <div className="card-tools">
                    {/* <DateRangeDropdown/> */}
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="collapse"
                    >
                      <i className="fas fa-minus"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="maximize"
                    >
                      <i className="fas fa-expand"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <CommonChart
                    chartData={currencyData}
                    options={chartOptions}
                  />
                </div>
              </div>
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3
                    className="card-title"
                    title="Collapse"
                    data-card-widget="collapse"
                    style={{ cursor: "pointer" }}
                  >
                    {" "}
                    &nbsp;&nbsp;<i className="far fa-chart-bar"></i>&nbsp;
                    Payment Method wise Successs Rate Time Series Chart
                  </h3>

                  <div className="card-tools">
                    {/* <DateRangeDropdown/> */}
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="collapse"
                    >
                      <i className="fas fa-minus"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="maximize"
                    >
                      <i className="fas fa-expand"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body ">
                  <CommonChart
                    chartData={paymentMethodData}
                    options={chartOptions}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SuccessRate;
